var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Footer',{staticClass:"app-footer"},[_c('p',[_vm._v("© 2021 上海九罗科技 有限公司 版权所有")])])}
var staticRenderFns = []

export { render, staticRenderFns }